import PersonalBookingPagePublishingSettings from './schema/PersonalBookingPagePublishingSettings';
import { createStore } from 'satcheljs';
import '../mutators/initializeSettingsMutator';

let initialStore: PersonalBookingPagePublishingSettings = {
    publishingSettings: null,
    isAnonymousSharingEnabled: false,
};

export default createStore<PersonalBookingPagePublishingSettings>(
    'personalBookingPagePublishingSettings',
    initialStore
);
